export const URL_PAGE_REGEXP = /\/([^/]+)/g
